"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const actionTypes_1 = require("./actionTypes");
const defaultSliceState = {
    isLoading: false,
    error: null,
    paging: {
        page: 0,
        nextPage: 0,
        prevPage: 0,
        hasNextPage: false,
        hasPrevPage: false,
        limit: 0,
        pagingCounter: 0,
        totalDocs: 0,
        totalPages: 0,
        isOutOfSync: false,
    },
    pages: [],
};
const sliceReducer = (state, action) => {
    var _a;
    switch (action.type) {
        case actionTypes_1.FETCH_VIEW: {
            return Object.assign(Object.assign({}, state), { isLoading: true });
        }
        case actionTypes_1.UPDATE_VIEW_PAGE: {
            const { docs, page = 0, paging = {} } = action;
            const serverDocSizeChanged = Boolean(state.paging.totalDocs && (paging === null || paging === void 0 ? void 0 : paging.totalDocs) && state.paging.totalDocs !== paging.totalDocs);
            const newState = Object.assign(Object.assign({}, state), { isLoading: false, paging: Object.assign(Object.assign({}, paging), { page, isOutOfSync: page > 1 && (((_a = state.paging) === null || _a === void 0 ? void 0 : _a.isOutOfSync) || serverDocSizeChanged) }) });
            newState.pages[page] = docs;
            return newState;
        }
        case actionTypes_1.SET_VIEW_ERROR: {
            const { error } = action;
            return Object.assign(Object.assign({}, state), { error });
        }
        default:
            return null;
    }
};
const viewsReducer = (state = {}, action) => {
    const { slice } = action, sliceAction = __rest(action, ["slice"]);
    if (!slice)
        return state;
    const newState = Object.assign({}, state);
    const currentSlice = newState[slice] || JSON.parse(JSON.stringify(defaultSliceState));
    const newSliceState = sliceReducer(currentSlice, sliceAction);
    if (newSliceState)
        newState[slice] = newSliceState;
    return newState;
};
exports.default = viewsReducer;
